/**
 * Print Error Codes
 *
 * Standardized error codes for print operations.
 * Used for error tracking, logging, and user feedback.
 */

/**
 * Enumeration of print error types.
 * Use these codes for consistent error handling and reporting.
 */
export enum PrintErrorCode {
  /** No labels in the print container */
  NO_LABELS = 'NO_LABELS',
  /** Label component failed to render */
  RENDER_FAILED = 'RENDER_FAILED',
  /** Unknown print error */
  UNKNOWN = 'UNKNOWN',
}

/**
 * Custom error class for print operations.
 * Includes error code for programmatic handling.
 */
export class PrintError extends Error {
  constructor(
    public readonly code: PrintErrorCode,
    message: string
  ) {
    super(message);
    this.name = 'PrintError';
  }
}

/**
 * Create a PrintError with NO_LABELS code.
 */
export function noLabelsError(): PrintError {
  return new PrintError(
    PrintErrorCode.NO_LABELS,
    'No labels found to print. Create a batch with orders first.'
  );
}

/**
 * Create a PrintError with RENDER_FAILED code.
 */
export function renderFailedError(details?: string): PrintError {
  return new PrintError(
    PrintErrorCode.RENDER_FAILED,
    details || 'Failed to render one or more labels.'
  );
}
